module.exports = "/shifts/components/shiftTemplateSelectionGroupComponent-5248cf.html";